
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { iPointsCard } from '@/interface/purchase';
import { setIOSId } from '@/api/coinManaging';
import { toast } from '@/utils/common';

@Component
export default class CloudCard extends Vue {
  @Prop({ type: Object, required: true }) info!: iPointsCard;
  @Prop({ default: false }) isShowPID!: boolean;
  hover: boolean = false;
  isUpdate: boolean = false;
  proName: string = '';
  id: number | null = null;
  @Emit('check')
  check() {
    return this.info;
  }
  @Emit('edit')
  edit() {
    return this.info;
  }
  strColor(str: string) {
    return str.replace(/([+]\d+[.]\d+|[-]\d+[.]\d+|\d+[.]\d+|[+]\d+|[-]\d+|\d+)/gi, '<span style="color:#ffde00">$&</span>');
  }
  getId(name: string) {
    if (name) {
      const str = name.split('.');
      const value = str[str.length - 1];
      str.pop();
      this.proName = str.join('.');
      this.id = JSON.parse(value);
      return value;
    } else {
      this.proName = 'cn.lingwoyun.cloudpc.coin';
    }
  }
  async handleSaveID() {
    try {
      if (this.isUpdate) {
        const data = { type: 1, id: this.info.id, apple_product_id: this.proName + '.' + this.id }; //type 1-云币包 2-周期卡
        const res: any = await setIOSId(data);
        if (res && res.code == 0) {
          this.isUpdate = false;
          this.$emit('successSaveIOSId', 1);
          toast('修改成功', 'success');
        } else {
          toast(res.msg, 'error');
        }
      } else {
        this.isUpdate = !this.isUpdate;
      }
    } catch (err) {
      console.log(err);
    }
  }
}
